import { logError } from '@office-start/telemetry-service';
export function logValidateConfigEqualityError(message) {
    logError({
        eventName: 'ValidateConfigEquality_Error',
        errorType: 'NorthStarConfig_Error',
        message: message,
    });
}
//# sourceMappingURL=logValidateConfigEqualityError.js.map